// Generated by `npm run themes:gen` from scripts/materialSchemes.ts — do not edit by hand.

/** The colour roles, in the order every scheme below lists its tones. */
export const ROLES = [
  'primary',
  'on-primary',
  'primary-container',
  'on-primary-container',
  'secondary',
  'on-secondary',
  'secondary-container',
  'on-secondary-container',
  'tertiary',
  'on-tertiary',
  'tertiary-container',
  'on-tertiary-container',
  'error',
  'on-error',
  'error-container',
  'on-error-container',
  'surface',
  'surface-dim',
  'surface-bright',
  'surface-container-lowest',
  'surface-container-low',
  'surface-container',
  'surface-container-high',
  'surface-container-highest',
  'on-surface',
  'on-surface-variant',
  'outline',
  'outline-variant',
  'inverse-surface',
  'inverse-on-surface',
  'inverse-primary',
  'success',
  'on-success',
  'success-container',
  'on-success-container',
  'warning',
  'on-warning',
  'warning-container',
  'on-warning-container',
] as const;

/** Each car colour's light and dark scheme, as space-separated `#rrggbb`s in `ROLES` order. */
export const SCHEMES: Record<number, { light: string; dark: string }> = {
  0xe8503a: {
    light: '#904b3f #ffffff #ffdad4 #73342a #775651 #ffffff #ffdad4 #5d3f3a #6f5c2e #ffffff #fae0a6 #564519 #ba1a1a #ffffff #ffdad6 #93000a #fff8f6 #e8d6d3 #fff8f6 #ffffff #fff0ee #fceae7 #f7e4e1 #f1dfdb #231918 #534340 #857370 #d8c2be #392e2c #ffedea #ffb4a7 #426900 #ffffff #c2f280 #112000 #974806 #ffffff #ffdbc8 #321300',
    dark: '#ffb4a7 #561e15 #73342a #ffdad4 #e7bdb5 #442925 #5d3f3a #ffdad4 #ddc48c #3d2e04 #564519 #fae0a6 #ffb4ab #690005 #93000a #ffdad6 #1a1110 #1a1110 #423735 #140c0b #231918 #271d1c #322826 #3d3230 #f1dfdb #d8c2be #a08c89 #534340 #f1dfdb #392e2c #904b3f #a7d567 #203600 #314f00 #c2f280 #ffb68a #522300 #743400 #ffdbc8',
  },
  0xffb020: {
    light: '#7f560f #ffffff #ffddb1 #624000 #6f5b40 #ffffff #fadebc #56442a #516440 #ffffff #d3eabc #394c2a #ba1a1a #ffffff #ffdad6 #93000a #fff8f4 #e4d8cc #fff8f4 #ffffff #fef2e5 #f8ecdf #f3e6da #ede0d4 #201b13 #4f4539 #817567 #d3c4b4 #362f27 #fbefe2 #f3bd6e #426900 #ffffff #c2f280 #112000 #855300 #ffffff #ffddb8 #2a1700',
    dark: '#f3bd6e #442b00 #624000 #ffddb1 #ddc2a1 #3e2e16 #56442a #fadebc #b7cea2 #243516 #394c2a #d3eabc #ffb4ab #690005 #93000a #ffdad6 #18120b #18120b #3f382f #120d07 #201b13 #251f17 #2f2921 #3b342b #ede0d4 #d3c4b4 #9b8f80 #4f4539 #ede0d4 #362f27 #7f560f #a7d567 #203600 #314f00 #c2f280 #ffb95f #472a00 #653e00 #ffddb8',
  },
  0x4cc38a: {
    light: '#266a4a #ffffff #acf2c8 #025233 #4e6355 #ffffff #d0e8d7 #364b3e #3c6472 #ffffff #bfe9f9 #234c59 #ba1a1a #ffffff #ffdad6 #93000a #f6fbf4 #d6dbd5 #f6fbf4 #ffffff #f0f5ee #eaefe9 #e4eae3 #dfe4dd #171d19 #404943 #707972 #c0c9c0 #2c322e #edf2ec #91d5ad #006d36 #ffffff #92f8ab #00210c #7d5700 #ffffff #ffdeaa #271900',
    dark: '#91d5ad #003822 #025233 #acf2c8 #b4ccbb #203529 #364b3e #d0e8d7 #a4cddd #043542 #234c59 #bfe9f9 #ffb4ab #690005 #93000a #ffdad6 #0f1511 #0f1511 #353b36 #0a0f0c #171d19 #1b211d #262b27 #303632 #dfe4dd #c0c9c0 #8a938b #404943 #dfe4dd #2c322e #266a4a #76db91 #003919 #005227 #92f8ab #f9bc49 #422c00 #5f4100 #ffdeaa',
  },
  0x39a0ff: {
    light: '#37618e #ffffff #d2e4ff #1b4975 #535f70 #ffffff #d7e3f8 #3c4858 #6b5778 #ffffff #f3daff #533f5f #ba1a1a #ffffff #ffdad6 #93000a #f8f9ff #d8dae0 #f8f9ff #ffffff #f2f3fa #eceef4 #e7e8ee #e1e2e8 #191c20 #43474e #73777f #c3c6cf #2e3135 #eff0f7 #a1c9fd #006d43 #ffffff #92f7bc #002111 #974806 #ffffff #ffdbc8 #321300',
    dark: '#a1c9fd #003259 #1b4975 #d2e4ff #bbc7db #253141 #3c4858 #d7e3f8 #d7bee4 #3b2947 #533f5f #f3daff #ffb4ab #690005 #93000a #ffdad6 #111418 #111418 #36393e #0b0e13 #191c20 #1d2024 #272a2f #32353a #e1e2e8 #c3c6cf #8d9199 #43474e #e1e2e8 #2e3135 #37618e #76daa1 #003920 #005231 #92f7bc #ffb68a #522300 #743400 #ffdbc8',
  },
  0xa06cff: {
    light: '#68548d #ffffff #ebdcff #503c74 #635b70 #ffffff #eadef8 #4b4358 #7f525d #ffffff #ffd9e1 #643b46 #ba1a1a #ffffff #ffdad6 #93000a #fef7ff #ded8e0 #fef7ff #ffffff #f8f1fa #f2ecf4 #ede6ee #e7e0e8 #1d1b20 #49454e #7a757f #cbc4cf #322f35 #f5eff7 #d3bcfd #006d43 #ffffff #92f7bc #002111 #974806 #ffffff #ffdbc8 #321300',
    dark: '#d3bcfd #39265c #503c74 #ebdcff #cdc2db #342d40 #4b4358 #eadef8 #f1b7c5 #4a2530 #643b46 #ffd9e1 #ffb4ab #690005 #93000a #ffdad6 #151218 #151218 #3b383e #0f0d13 #1d1b20 #211f24 #2c292f #37343a #e7e0e8 #cbc4cf #948f99 #49454e #e7e0e8 #322f35 #68548d #76daa1 #003920 #005231 #92f7bc #ffb68a #522300 #743400 #ffdbc8',
  },
  0xff6bb5: {
    light: '#894a67 #ffffff #ffd8e6 #6e334f #735761 #ffffff #fed9e6 #593f4a #7e5538 #ffffff #ffdcc6 #633e23 #ba1a1a #ffffff #ffdad6 #93000a #fff8f8 #e5d6da #fff8f8 #ffffff #fff0f3 #faeaee #f4e4e8 #eedfe2 #21191c #504348 #837378 #d4c2c7 #372e31 #fdedf1 #ffb0d0 #426900 #ffffff #c2f280 #112000 #974806 #ffffff #ffdbc8 #321300',
    dark: '#ffb0d0 #531d38 #6e334f #ffd8e6 #e1bdca #412a33 #593f4a #fed9e6 #f1bb98 #49280f #633e23 #ffdcc6 #ffb4ab #690005 #93000a #ffdad6 #191114 #191114 #40373a #130c0f #21191c #251d20 #30282b #3b3235 #eedfe2 #d4c2c7 #9d8c92 #504348 #eedfe2 #372e31 #894a67 #a7d567 #203600 #314f00 #c2f280 #ffb68a #522300 #743400 #ffdbc8',
  },
  0xf2f2f2: {
    light: '#516164 #ffffff #d4e6e9 #39494c #576062 #ffffff #dbe4e6 #3f484a #4a6267 #ffffff #cde7ec #334b4f #ba1a1a #ffffff #ffdad6 #93000a #faf9f9 #dbdad9 #faf9f9 #ffffff #f4f3f3 #efeded #e9e8e8 #e3e2e2 #1b1c1c #464747 #777777 #c7c6c6 #2f3031 #f2f0f0 #b8cacd #006d43 #ffffff #92f7bc #002111 #7d5700 #ffffff #ffdeaa #271900',
    dark: '#b8cacd #233336 #39494c #d4e6e9 #bfc8ca #293234 #3f484a #dbe4e6 #b1cbd0 #1c3438 #334b4f #cde7ec #ffb4ab #690005 #93000a #ffdad6 #121414 #121414 #383939 #0d0e0f #1b1c1c #1f2020 #292a2a #343535 #e3e2e2 #c7c6c6 #919191 #464747 #e3e2e2 #2f3031 #516164 #76daa1 #003920 #005231 #92f7bc #f9bc49 #422c00 #5f4100 #ffdeaa',
  },
  0x2c333d: {
    light: '#575f6b #ffffff #dbe3f1 #3f4753 #5a5f66 #ffffff #dfe2eb #43474e #535f70 #ffffff #d7e3f8 #3c4858 #ba1a1a #ffffff #ffdad6 #93000a #fbf9fa #dcd9db #fbf9fa #ffffff #f5f3f4 #f0edee #eae7e9 #e4e2e3 #1b1b1d #474648 #777778 #c8c6c7 #303031 #f3f0f1 #bfc7d5 #006d43 #ffffff #92f7bc #002111 #974806 #ffffff #ffdbc8 #321300',
    dark: '#bfc7d5 #29313c #3f4753 #dbe3f1 #c3c6cf #2c3137 #43474e #dfe2eb #bbc7db #253141 #3c4858 #d7e3f8 #ffb4ab #690005 #93000a #ffdad6 #131314 #131314 #39393a #0e0e0f #1b1b1d #1f1f21 #2a2a2b #353536 #e4e2e3 #c8c6c7 #919092 #474648 #e4e2e3 #303031 #575f6b #76daa1 #003920 #005231 #92f7bc #ffb68a #522300 #743400 #ffdbc8',
  },
};
